const activityList = [
  { name: "On day of Activity", value: 0 },
  { name: "1 day before activity", value: 1 },
  { name: "2 days before activity", value: 2 },
];

export default activityList;
